
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { SectionTitle } from "@/components/section-title";
import { services } from "../constants";
import type { Feature } from "../constants";

function ServiceIcon({ src, alt }: { src: string; alt: string }) {
    return <img src={src} alt={alt} className="h-14 w-14" loading="lazy" />;
}

export function Services() {
    return (
        <section id="servicos" className="grid gap-8 scroll-mt-28">
            <SectionTitle
                eyebrow="Nossos Serviços"
                title="Soluções de IA para cada desafio"
                subtitle="Combinamos expertise técnica e visão de negócios para entregar soluções que realmente transformam."
            />
            <div className="grid gap-5 md:grid-cols-3">
                {services.map((service: Feature) => (
                    <Card
                        key={service.title}
                        className="border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm dark:shadow-[0_20px_80px_rgba(0,0,0,0.35)] backdrop-blur transition-all duration-300 hover:border-cyan-500/50 dark:hover:bg-white/10 hover:bg-slate-50"
                    >
                        <CardHeader className="gap-4">
                            <ServiceIcon src={service.icon} alt={service.title} />
                            <CardTitle className="text-xl text-slate-900 dark:text-white">{service.title}</CardTitle>
                            <CardDescription className="text-slate-600 dark:text-slate-200/70 text-base leading-relaxed">
                                {service.description}
                            </CardDescription>
                        </CardHeader>
                    </Card>
                ))}
            </div>
        </section>
    );
}
